import React from "react";
import GenericModal from "../../../../components/modal/GenericModal";

const MensajeConfirmacionModal = ({ idCuadroSede, toggleModal, reprocesarCuadroSede }) => {
  return (
    <GenericModal showModal={toggleModal} width="500px" titulo={`Reprocesar`}>
      <div className="modal-body pt-0 pl-0">
        <div className="container-fluid">
            <p>
                Se van a borrar las asignaciones, resetear el responsable y casos generados.
            </p>
            <p className="mb-0">
                ¿Está seguro de esta acción?
            </p>
        </div>
      </div>

      <div className="modal-footer d-flex justify-content-end">
        <div className="button">
          <button
            className="btn btn-primary generic-button-ficha mr-2"
            onClick={toggleModal}
          >
            Cancelar
          </button>
          <button
            className="btn btn-primary generic-button-ficha"
            onClick={async () => {
                toggleModal();
                await reprocesarCuadroSede(idCuadroSede);
            }}
          >
            Aceptar
          </button>
        </div>
      </div>
    </GenericModal>
  );
};

export default MensajeConfirmacionModal;
